import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AttendanceBatchPayload, AttendanceDayRecord } from '../models/attendance.model';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  private readonly base = `${environment.apiUrl}/attendance`;

  constructor(private http: HttpClient) { }

  /**
   * Existing marks for a class on a calendar day.
   * Backend: GET /attendance?date=YYYY-MM-DD&className=10
   */
  getDayRecords(date: string, className: string): Observable<AttendanceDayRecord[]> {
    const params = new HttpParams().set('date', date).set('className', className);
    return this.http.get<AttendanceDayRecord[]>(this.base, { params }).pipe(
      catchError(() => of([]))
    );
  }

  /**
   * Save marks for the class/day.
   * Backend: POST /attendance/batch with AttendanceBatchPayload
   */
  saveBatch(payload: AttendanceBatchPayload): Observable<void> {
    return this.http.post<void>(`${this.base}/batch`, payload);
  }
}
